import React from 'react';

import { BrowserRouter, Routes, Route } from 'react-router';

import DebriefThemeProvider from 'ff/debrief/components/DebriefThemeProvider';
import ToastBar from 'ff/debrief/components/ToastBar';
import SharePageRoute, {
    pathString,
} from 'ff/debrief/router/routes/SharePageRoute';
import LegacyShareRoute, {
    pathString as legacySharePath,
} from 'ff/debrief/router/routes/LegacyShareRoute';
import MapGridLayout from 'ff/debrief/layouts/MapGridLayout';

const ShareApp = () => {
    return (
        <DebriefThemeProvider>
            <BrowserRouter basename="/shared">
                <Routes>
                    <Route Component={MapGridLayout}>
                        <Route path={pathString} element={<SharePageRoute />} />
                        <Route
                            path={legacySharePath}
                            element={<LegacyShareRoute />}
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
            <ToastBar />
        </DebriefThemeProvider>
    );
};

export default ShareApp;
